// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__3lEly","img":"Modal_img__1Av7V","closeButton":"Modal_closeButton__8C_Tm"};